import ValidationObserver from '/@/modules/core/form/components/ValidationObserver.vue';
import BaseFlowControlButtons from '/@/modules/core/form/components/BaseFlowControlButtons.vue';
import FlowDetailCard from '/@/modules/core/form/components/FlowDetailCard.vue';
import { BaseFlowFormService } from '/@/modules/core/form/services/BaseFlowFormService';

export const FormFlowMixin = {
  emits: ['flow-change', 'input', 'submit', 'submit-add-another'],
  components: {
    ValidationObserver,
    BaseFlowControlButtons,
    FlowDetailCard
  },
  props: {
    service: {
      // Object as PropType<BaseFlowFormService>
      type: Object
    }
  },
  data() {
    return {
      form: this.value
    };
  },
  methods: {
    flow(component) {
      this.$emit('flow-change', component);
    },
    submit() {
      this.$emit('input', this.form);
      this.$emit('submit');
    },
    addAnother() {
      this.$emit('submit-add-another');
    }
  }
};
